import React from "react";
import { makeStyles, Box } from "@material-ui/core";

import { bordo, green } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  operatorImg: {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    [down("xs")]: {
      height: "33px",
      width: "33px",
    },
  },
  statusBox: {
    position: "relative",
  },
  redDot: {
    position: "absolute",
    top: "9px",
    right: 0,
    width: "18px",
    height: "18px",
    backgroundColor: "red",
    borderRadius: "50%",
    border: `3px solid ${bordo}`,
    [down("xs")]: {
      top: "5px",
      width: "7px",
      height: "7px",
      border: `1px solid ${bordo}`,
    },
  },
  greenDot: {
    position: "absolute",
    top: "9px",
    right: 0,
    width: "18px",
    height: "18px",
    background: green,
    borderRadius: "50%",
    border: `3px solid ${bordo}`,
    [down("xs")]: {
      top: "5px",
      width: "7px",
      height: "7px",
      border: `1px solid ${bordo}`,
    },
  },
}));

const OperatorStatus = ({ logoSrc, status }) => {
  const { operatorImg, greenDot, redDot, statusBox } = useStyles();
  return (
    <Box className={statusBox}>
      <img src={logoSrc} alt="operator-img" className={operatorImg} />
      <Box className={status ? greenDot : redDot} />
    </Box>
  );
};

export default OperatorStatus;
